import React, { useEffect, useState } from "react";
import "../assets/css/Contact.css";
import data from "../../src/component/ApiUrl/meta_api";
import { Helmet } from "react-helmet";
import AOS from "aos";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";

function Contact() {
  const [meta, setMeta] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState("address1");

  const fetchData = () => {
    const ContactMeta = data[0]?.contact_page;
    if (ContactMeta) {
      setMeta(ContactMeta);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  const maps = {
    address1:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2132.9529950693664!2d77.71513484878855!3d11.345442836854506!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba96f374cc6d053%3A0xe53b45daced3e311!2sSATHYA%20IAS%20ACADEMY!5e0!3m2!1sen!2sin!4v1771238090566!5m2!1sen!2sin" 
    // address2:
    //   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1952.0386059032712!2d78.132062!3d11.668063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babf06a4250b42d%3A0x179df87f55718994!2sSri%20PR%20Aarcade!5e0!3m2!1sen!2sin!4vYOUR_UNIQUE_CODE",
  };

  const addressData = {
    address1: {
      phone: "+91-824 801 0909",
      email: "info@skimitarautomation.com",
      location:
        "1st Floor,D.No:027,Ward 25th,2nd Cross,Annamalai Layout,Nalli Hospital Road, Erode -638011",
    },
        // address2: {
        //   phone: "+91-824 801 0909",
        //   email: "info@skimitarautomation.com",
        //   location: "G-1,230, Sri P.R.Arcade, Itteri Road, Ram Nagar",
        // },
  };

  const ContactCard = ({ icon, title, subtitle, content }) => (
    <div
      className="card h-100 border-0 shadow-sm mb-3"
      style={{ borderRadius: "10px" }}
    >
      <div className="card-body p-4 d-flex flex-column">
        <div className="d-flex align-items-center mb-3">
          <div
            className="btn-square bg-white rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{
              width: "60px",
              height: "60px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            {icon}
          </div>
          <div>
            <h6 className="mb-0">{title}</h6>
            <h6 className="text-danger">{subtitle}</h6>
          </div>
        </div>
        <div className="mt-auto text-center">
          {" "}
          {/* Only added text-center here */}
          <p className="mb-0">{content}</p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Contact"}</title>
      </Helmet>

      {/* Header Section */}
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <h1 className="display-3 text-white animated slideInRight">
            Contact
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animated slideInRight mb-0">
              <li className="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Contact
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-xxl ">
        <div className="container">
          {/* Branches Section */}
          <div className="text-center mb-2">
            {/* <h3 className="text-danger"></h3> */}
            <h2
              className="text-gradient-primary fw-bold mt-1 "
              data-aos="fade-left"
            >
              Our Branches
            </h2>
          </div>

          {/* Address Selector */}
          <div className="row mb-4 justify-content-center">
            <div className="col-md-8 text-center">
              <div className="btn-group" role="group">
                <button
                  className={`btn ${
                    selectedAddress === "address1"
                      ? "btn-danger"
                      : "btn-outline-dark"
                  }`}
                  onClick={() => setSelectedAddress("address1")}
                >
                  <FaMapMarkerAlt className="me-2" /> Erode
                </button>
                {/* <button
                  className={`btn ${
                    selectedAddress === "address2"
                      ? "btn-danger"
                      : "btn-outline-dark"
                  }`}
                  onClick={() => setSelectedAddress("address2")}
                >
                  <FaMapMarkerAlt className="me-2" /> Salem
                </button> */}
              </div>
            </div>
          </div>

          {/* Map and Contact Cards Section */}
          <div className="row mb-5">
            {/* Contact Cards - Left Side (Vertical) */}


            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="pe-3">
                <ContactCard
                  icon={<FaPhone className="fa-2x text-danger" />}
                  title="24*7 SERVICES..."
                  subtitle="CALL US ON"
                  content={addressData[selectedAddress].phone}
                />
                <ContactCard
                  icon={<FaEnvelope className="fa-2x text-danger" />}
                  title="DROP A LINE..."
                  subtitle="MAIL ADDRESS"
                  content={addressData[selectedAddress].email}
                />
                <ContactCard
                  icon={<FaMapMarkerAlt className="fa-2x text-danger" />}
                  title="LOCATION..."
                  subtitle="VISIT US AT"
                  content={addressData[selectedAddress].location}
                />
              </div>
            </div>

            {/* Map - Right Side */}
            <div className="col-lg-8">
              <div
                className="card border-0 h-80 shadow-sm"
                style={{ borderRadius: "10px" }}
              >
                <iframe
                  key={selectedAddress}
                  className="w-100"
                  src={maps[selectedAddress]}
                  frameBorder="0"
                  style={{
                    minHeight: "500px",
                    border: "none",
                    borderRadius: "10px",
                  }}
                  allowFullScreen
                  aria-hidden="false"
                  tabIndex="0"
                  loading="lazy"
                ></iframe>
              </div>
              <div className="text-center mt-3">
                {/* <h5 className="fw-bold">
                  <FaMapMarkerAlt className="me-2 text-danger" />
                  {selectedAddress === "address1"
                    ? "29, Pavadai St, Erode, Tamil Nadu"
                    : "Sri PR Arcade, Salem, Tamil Nadu"}
                </h5> */}
              </div>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="row py-5">
            <div className="col-lg-5 mb-4 mb-lg-0 ContactUs">
              <div
                className="card border-0 shadow-lg p-4 text-white h-100"
                style={{
                  background:
                    "linear-gradient(135deg,rgb(224, 44, 44),rgb(238, 100, 100))",
                  borderRadius: "10px",
                }}
              >
                <h3 className="card-header text-center fw-bold bg-transparent border-0 text-light">
                  Contact Us
                </h3>
                <div className="card-body">
                  <p className="text-light fs-4 text-center fw-bold text-dark">
                    Have a question? Need a consultation? Reach out to us, and
                    we'll get back to you shortly.
                  </p>
                  <div className="d-flex flex-column gap-4">
                    <div className="d-flex align-items-center flex-wrap mt-5">
                      <div
                        className="d-flex justify-content-center align-items-center bg-danger rounded-circle shadow-lg"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <FaPhone className="text-white fs-5" />
                      </div>
                      <div className="ms-2 text-break">
                        <h6 className="mb-0 text-white fw-bold">Call Us</h6>
                        <span
                          className="text-white h5"
                          style={{ wordBreak: "break-word" }}
                        >
                          +91-824 801 0909
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap mt-5">
                      <div
                        className="d-flex justify-content-center align-items-center bg-danger rounded-circle p-2"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <FaEnvelope className="text-white fs-5" />
                      </div>
                      <div className="ms-2 text-break">
                        <h6 className="mb-0 text-white fw-bold">Mail Us</h6>
                        <span
                          className="text-white h5"
                          style={{ wordBreak: "break-word" }}
                        >
                          info@skimitarhindusthan.com
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 offset-lg-1">
              <div
                className="card p-4 border-0 shadow-lg h-100"
                style={{
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "10px",
                }}
              >
                <h4 className="text-center text-dark fw-bold mb-4">
                  Get In Touch
                </h4>
                <form>
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control rounded-4"
                          id="name"
                          placeholder="Your Name"
                        />
                        <label htmlFor="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control rounded-4"
                          id="email"
                          placeholder="Your Email"
                        />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control rounded-4"
                          id="subject"
                          placeholder="Subject"
                        />
                        <label htmlFor="subject">Subject</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control rounded-4"
                          placeholder="Leave a message here"
                          id="message"
                          style={{ height: "150px" }}
                        ></textarea>
                        <label htmlFor="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12 d-flex justify-content-center">
                      <button
                        className="btn w-50 py-3 text-white rounded-4 bg-danger fw-bold"
                        type="submit"
                      >
                        Send
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
